module.exports = __webpack_public_path__ + "static/media/bench_press.06032426.mp4";